var map = {
	"./finezzi.png": "5e5b",
	"./mille.png": "80d8",
	"./titanio.png": "f146",
	"./topazio.png": "97c9",
	"./toronto.png": "7012",
	"./trevo.png": "6b24",
	"./trovato.png": "dac2",
	"./tuboflex.png": "6177",
	"./turquesa.png": "b4c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fa5f";